import React, { useState } from 'react';
import { SlotGame } from './slotgame-1/SlotGame';
import Login from './login/Login';
import GameLayout from './components/GameLayout';
import './App.css';
import { db } from './Firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { verifyLogin } from './services/authService';
import { SlotGame as SlotGame2 } from './slotgame-2/SlotGame2';
import { SlotGame as SlotGame3 } from './slotgame-3/SlotGame3';
import MatchGame from './matchgame/matchgame';
// Import SolveGame and SelectGame (aliased)
import SolveGame from './Solvegame/solvegame';
import SelectGame from './Selectgame/selectgame';
import { Routes, Route, Navigate } from 'react-router-dom';
import Leaderboard from './leaderboard/Leaderboard';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isAutoLoggingIn, setIsAutoLoggingIn] = useState(true);

  // ตรวจสอบ Auto Login
  React.useEffect(() => {
    const checkAutoLogin = async () => {
      const storedCredentials = localStorage.getItem('user_credentials');
      if (storedCredentials) {
        try {
          const { username, password } = JSON.parse(storedCredentials);
          const result = await verifyLogin(username, password);
          if (result.success) {
            handleLoginSuccess(result.data);
          }
        } catch (error) {
          console.error("Auto login failed:", error);
          localStorage.removeItem('user_credentials'); // ลบข้อมูลถ้า error
        }
      }
      setIsAutoLoggingIn(false);
    };
    checkAutoLogin();
  }, []);

  // Safety check: Reset count if it reaches 33 or more (Cycle reset)
  React.useEffect(() => {
    // Log for verification
    if (userData) {
      // console.log("Startup Check - Current Count:", userData.count);
    }
    
    if (userData && userData.count >= 30) {
       const resetCount = async () => {
          try {
            const collectionName = userData.collection || "Student-history";
            const docId = userData.id || userData.username;
            const userRef = doc(db, collectionName, docId);
            await setDoc(userRef, { count: 0 }, { merge: true });
            handleUserUpdate(userData.username);
          } catch (error) {
            console.error("Error auto-resetting count:", error);
          }
       };
       resetCount();
    }
  }, [userData]);

  const handleLoginSuccess = (data) => {
    setUserData(data);
    setIsLoggedIn(true);
  };

  const handleUserUpdate = async (username) => {
    if (!userData) return;
    
    try {
      // ใช้ข้อมูล collection/id จาก userData เดิม
      const collectionName = userData.collection || "Student-history";
      const docId = userData.id || username;
      
      const userRef = doc(db, collectionName, docId);
      const docSnap = await getDoc(userRef);
      
      if (docSnap.exists()) {
        const newData = docSnap.data();
        setUserData(prev => ({
          ...prev,
          ...newData,
          // คงค่า meta data เดิมไว้
          collection: prev.collection, 
          id: prev.id
        }));
      }
    } catch (error) {
      console.error("Error refreshing user data:", error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user_credentials');
    setIsLoggedIn(false);
    setUserData(null);
  };

  // Helper function to manually increment count (for modal games)
  const manualIncrementCount = async () => {
    if (userData) {
      const collectionName = userData.collection || "Student-history";
      const docId = userData.id || userData.username;
      const userRef = doc(db, collectionName, docId);
      try {
        const newCount = (userData.count || 0) + 1;
        await setDoc(userRef, { count: newCount }, { merge: true });
        handleUserUpdate(userData.username);
      } catch (error) {
        console.error("Error manually incrementing count:", error);
      }
    }
  };

  return (
    <div className="App">
      {isAutoLoggingIn ? (
        <div className="loading-screen" style={{color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '1.5rem'}}>
          กำลังเข้าสู่ระบบ...
        </div>
      ) : !isLoggedIn ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        <Routes>
          <Route path="/leaderboard" element={<Leaderboard userData={userData} />} />
          <Route path="/" element={
            <GameLayout userData={userData} onLogout={handleLogout}>
              {(() => {
                const count = userData?.count || 0;

                // 1. SlotGame-2 : count = 0 - 4
                if (count >= 0 && count <= 4) {
                  return <SlotGame2 userData={userData} onUserUpdate={handleUserUpdate} />;
                } 
                // 2. SelectGame : count = 5
                else if (count === 5) {
                  return (
                    <SelectGame 
                      userData={userData} 
                      onUserUpdate={handleUserUpdate} 
                      visible={true} 
                      onClose={manualIncrementCount}
                    />
                  );
                }
                // 3. SlotGame-1 : count = 6 - 8
                else if (count >= 6 && count <= 8) {
                  return <SlotGame userData={userData} onUserUpdate={handleUserUpdate} />;
                }
                // 4. MatchGame : count = 9
                else if (count === 9) {
                  return (
                    <MatchGame 
                      userData={userData} 
                      onUserUpdate={handleUserUpdate} 
                      visible={true} 
                      onClose={manualIncrementCount}
                    />
                  );
                }
                // 5. SlotGame-2 : count = 10 - 14
                else if (count >= 10 && count <= 14) {
                   return <SlotGame2 userData={userData} onUserUpdate={handleUserUpdate} />;
                }
                // 6. SolveGame : count = 15
                else if (count === 15) {
                   return (
                    <SolveGame 
                      userData={userData} 
                      onUserUpdate={handleUserUpdate} 
                      visible={true} 
                      onClose={manualIncrementCount}
                    />
                  );
                }
                // 7. SlotGame-1 : count = 16 - 18
                else if (count >= 16 && count <= 18) {
                   return <SlotGame userData={userData} onUserUpdate={handleUserUpdate} />;
                }
                // 8. SelectGame : count = 19
                else if (count === 19) {
                   return (
                    <SelectGame 
                      userData={userData} 
                      onUserUpdate={handleUserUpdate} 
                      visible={true} 
                      onClose={manualIncrementCount}
                    />
                  );
                }
                // 9. SlotGame-2 : count = 20 - 24
                else if (count >= 20 && count <= 24) {
                   return <SlotGame2 userData={userData} onUserUpdate={handleUserUpdate} />;
                }
                // 10. MatchGame : count = 25
                else if (count === 25) {
                   return (
                    <MatchGame 
                      userData={userData} 
                      onUserUpdate={handleUserUpdate} 
                      visible={true} 
                      onClose={manualIncrementCount}
                    />
                  );
                }
                // 11. SlotGame-1 : count = 26 - 28
                else if (count >= 26 && count <= 28) {
                   return <SlotGame3 userData={userData} onUserUpdate={handleUserUpdate} />;
                }
                // 12. SolveGame : count = 29
                else if (count === 29) {
                   return (
                    <SolveGame 
                      userData={userData} 
                      onUserUpdate={handleUserUpdate} 
                      visible={true} 
                      onClose={manualIncrementCount}
                    />
                  );
                }
                // Reset Condition handled in useEffect (count >= 30)
                else {
                    return <SlotGame2 userData={userData} onUserUpdate={handleUserUpdate} />;
                }
              })()}
            </GameLayout> 
          } />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      )}
    </div>
  );
}

export default App;